module.exports = __webpack_public_path__ + "img/logo.ffe39dec.svg";